import { Spinner, Box, Image, useBreakpointValue, Center, Text, VStack } from "@chakra-ui/react"
import BarLoader from "react-spinners/BarLoader"
import youtube from "../AssetsTube/logo.png"
import NProgress from "nprogress"
import "nprogress/nprogress.css"
import { useContext } from "react"
import { MyContext } from "../contexts/AuthContext"



function Loadspinner({toggleProp}){

    let mobileView = useBreakpointValue({
        base: true,
        md: false
      })
    
     
    
      // This is to target the md or tablet/ipad view
      let tabletView = useBreakpointValue({
        md: true,
        lg:false
      })
    

    return(
        <div>
            <Center minHeight="100vh"   style={{background: "rgba(0, 0, 0, 1)", color: "#fff"}} >
                <VStack >
                <Box mb={10}>
                <Image src={youtube}  width="auto" height={mobileView? "70px": "175px"} /> {/*default mobileView 100px */}
                </Box>
                <BarLoader width={150} color="#fff" />

                {/* <Spinner size="xl" width={70} height={70} borderWidth={5} color="blue.600" /> */}
                {/* <Text fontSize="xl">Loading...</Text> */}

                </VStack>

            </Center>
            

        </div>
    )
}

export default Loadspinner






export function LoadCircleLogin(){
let {colorMode,setColorMode} = useContext(MyContext)

let mobileView = useBreakpointValue({
base:true,
md:false
})  
 
return(
    <div>
      <VStack width="100%" maxW="full" style={{backgroundColor:colorMode==="Dark"? "#181818":"white"}}>
        <Center  minHeight={mobileView? "100dh": "100vh"}  color={colorMode==="Dark"&& "white" }  >   {/*colorMode==="Dark"? "#181818" */}
        <VStack>
            <Spinner size="xl" width={70} height={70} borderWidth={8} color="#ff0000"  emptyColor="#404040" speed="0.65s"  />
            <Text fontSize="xl">Logging in...</Text>
            </VStack>
        </Center>        
    </VStack>
    </div>
)
    
}



export function LoadCircle({text}){
    
    let {colorMode,setColorMode} = useContext(MyContext)

    let mobileView = useBreakpointValue({
        base:true,
        md:false
    })

    return(
        <VStack width="100%" maxW="full" style={{backgroundColor:colorMode==="Dark"? "#181818":"white"}}>
            <Center  minHeight={mobileView? "100dh": "100vh"} color={colorMode==="Dark"&& "white" }  >   {/*colorMode==="Dark"? "#181818" */}
                <VStack>
                <Spinner size="xl" width={70} height={70} borderWidth={8} color="#ff0000"  emptyColor="#404040" speed="0.65s"  />
                <Text fontSize="xl">{text|| "Loading..."}</Text>
                </VStack>

            </Center>
            

        </VStack>
    )
}





NProgress.configure({
    showSpinner: false,
    tricklSpeed: 160,
    minimum: 0.15,
});


export {NProgress}